import MuiTableHead, { TableHeadProps } from '@mui/material/TableHead';
import { FC } from 'react';
import { YodaColors } from 'yoda-ui/yodaTheme';

const TableHead: FC<TableHeadProps> = (props) => (
  <MuiTableHead
    { ...props }
    sx={
      {
        ...props.sx as object,
        '& .MuiTableCell-head': {
          color: YodaColors.blue7,
        },
      }
    }
  />
);

export default TableHead;
